<template>
    <div class="mini-chart" ref="chartRef"></div>
</template>

<script setup>
import { onMounted, ref, watch, onUnmounted } from 'vue'
// ⭕ 按需引入 ECharts（极大减少打包体积）
import * as echarts from 'echarts/core'
import { LineChart } from 'echarts/charts'
import { GridComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的模块（必不可少）
echarts.use([LineChart, GridComponent, CanvasRenderer])

const props = defineProps({
    data: {
        type: Array,
        required: true,
    },
    color: {
        type: String,
        default: '#E74C3C' // 默认红色
    }
})

const chartRef = ref(null)
let chartInstance = null

onMounted(() => {
    initChart()
})

watch(() => props.data, () => {
    updateChart()
})
watch(() => props.color, () => {
    updateChart()
})

function initChart() {
    if (!chartRef.value) return


    chartInstance = echarts.init(chartRef.value, null, {
        renderer: 'canvas',
        devicePixelRatio: window.devicePixelRatio,
    })
    updateChart()
}


function updateChart() {
    if(!props.data?.length){
        return
    }
    if (!chartInstance) return;
    chartInstance.clear();

    const xData = props.data.map(item =>
        new Date(item.date).toLocaleTimeString('es-AR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'America/Argentina/Buenos_Aires'
        })
    );
    const yData = props.data.map(item => parseFloat(item.price));

    const min = Math.min(...yData);
    const max = Math.max(...yData);

    chartInstance.setOption({
        grid: {
            top: 1,
            bottom: 1,
            left: 0,
            right: 0
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,   // 必须加，不然左右都会留白
            show: false,
            data: xData,
            axisLabel: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
        },
        yAxis: {
            type: 'value',
            show: false,
            min: min,
            max: max,
            axisLabel: {
                show: false,        // 隐藏标签
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            splitLine: {
                show: false,        // 如果有 splitLine 会撑开
            },
        },
        series: [
            {
                type: 'line',
                data: yData,
                smooth: false,
                symbol: 'none',
                lineStyle: {
                    color: props.color,
                    width: 1
                },
                // areaStyle: {
                //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //         { offset: 0, color: `${props.color}20` },
                //         { offset: 1, color: `${props.color}00` }
                //     ])
                // }
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            { offset: 0, color: `${props.color}20` },
                            { offset: 1, color: `${props.color}00` }
                        ]
                    }
                }

            }
        ],
    });
}


onUnmounted(() => {
    if (chartInstance) {
        chartInstance.dispose()
        chartInstance = null
    }
})
</script>

<style scoped>
.mini-chart {
    width: 100%;
    height: 100%;
}
</style>